import { render, staticRenderFns } from "./ExpenseDialog.vue?vue&type=template&id=09c51436&scoped=true"
import script from "./ExpenseDialog.vue?vue&type=script&lang=js"
export * from "./ExpenseDialog.vue?vue&type=script&lang=js"
import style0 from "./ExpenseDialog.vue?vue&type=style&index=0&id=09c51436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c51436",
  null
  
)

export default component.exports